var render = function render(){var _vm=this,_c=_vm._self._c;return _c('widgetModal',{attrs:{"title":_vm.questionnaire.title,"subtitle":_vm.questionnaire.user
      ? 'Created by ' +
        _vm.questionnaire.user.first_name +
        ' ' +
        _vm.questionnaire.user.last_name
      : '',"btnlefttext":"","btncentertext":"Close","btnrighttext":"","leftloading":false,"rightloading":false,"centerloading":false,"footerhidden":false,"footer_padding":"20px 20px","header_padding":"20px 20px 5px 20px","body_padding":"0px 20px","width":"580px"},on:{"onCenterClick":_vm.onCancel}},[_c('div',{staticClass:"widget-modal-body-noscoll"},[_c('div',{staticClass:"questionnaire-description"},[_vm._v(" "+_vm._s(_vm.questionnaire.description)+" ")]),_c('Questionaire',{attrs:{"value":_vm.questionnaire.question}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }